<template>
    <Modal v-model="modalShow" :width="600" title="选择班级" :footer-hide="true" :closable="false">
        <div style="height:600px;overflow-y: scroll;">
            <el-tree node-key='id' ref="tree" @check="checktraveFun" :default-expanded-keys='expandedList' show-checkbox :data="data"
                :props="defaultProps" :default-checked-keys="defaultId"></el-tree>
        </div>
        <div class="modal-footer">
            <Button @click="close">取消</Button>
            <Button type="primary" @click="handleSureBtn">确定</Button>
        </div>
    </Modal>
</template>
<script>
import eduCenter from "@/request/eduCenter/index.js";
import { mapState } from 'vuex';
export default {
    props: {
        initclassId: {
            type: Array,
            default: () => []
        },
        ctype: {
            type: String,
            default: ''
        },
        optype: {
            type: String,
            default: '' 
        },
        orgId: {
            type: String,
            default: '' 
        },
    },
    data() {
        return {
            expandedList:[],
            modalShow: false,
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            childArray: [],
            defaultId: [],
            firstInit:false
        };
    },
    watch: {
    },
    methods: {
        async initData() {
            let params = { orgId: this.orgId }
            console.log("this.ctype", this.ctype)
            this.defaultId = [];
            this.data = [];
            const res = await eduCenter.getlistClassApi(params);
            if (res.status === 200) {
                console.log("res", res);
                this.data = this.initTreeData(res.message);
                // 全校模式 默认全选
                if (this.ctype == 'SCHOOL' && this.optype == 'add' && !this.firstInit) {
                    this.firstInit = true;
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys([1]);
                    })
                }
            }
        },
        initTreeData(msg) {
            let isSchool = this.ctype == 'SCHOOL'?true:false;
            this.expandedList = [];
            this.childArray = [];
            let data = [msg];
            let result = [], mockId = 0;
            data.map((item) => {
                mockId++;
                this.expandedList.push(mockId)
                let school = {
                    id: mockId,
                    label: item.shortName,
                    children: []
                }
                let childrenSchool = [];
                item.branches.map((item2) => {
                    mockId++;
                    this.expandedList.push(mockId)
                    let branch = {
                        id: mockId,
                        label: item2.branchName,
                        children: []
                    }
                    let childrenBranch = [];
                    item2.grades.map((item3) => {
                        mockId++;
                        if(!isSchool){
                            this.expandedList.push(mockId)
                        }
                        let grade = {
                            id: mockId,
                            label: item3.gradeName,
                            children: []
                        }
                        let childrenGrade = [];
                        item3.classes.map((item4) => {
                            mockId++;
                            let classobj = {
                                id: mockId,
                                label: item4.className,
                                classId: item4.classId,
                                num:item4.num
                            }
                            childrenGrade.push(classobj);
                            this.childArray.push(classobj);
                            if (this.initclassId.indexOf(item4.classId) > -1) {
                                this.defaultId.push(mockId);
                            }
                        })
                        grade.children = childrenGrade;
                        childrenBranch.push(grade);
                    })
                    branch.children = childrenBranch;
                    childrenSchool.push(branch);
                })
                school.children = childrenSchool;
                result.push(school)
            })
            console.log("this.defaultId", this.defaultId)
            return result;
        },
        getData() {
            let selectId = this.$refs.tree.getCheckedKeys() ? JSON.parse(JSON.stringify(this.$refs.tree.getCheckedKeys())) : [];
            let resultId = [];
            let num = 0;
            selectId.map((id) => {
                this.childArray.map((item) => {
                    if (item.id == id) {
                        resultId.push(item.classId);
                        num += item.num
                    }
                })
            })
            return { resultId,num };
        },
        checktraveFun(e, b) {
            console.log("b", b.checkedKeys)
            // this.delTraveKey = b.checkedKeys;
        },
        handleNodeClick(e) {
            console.log("eee", e);
        },
        // 打开弹窗
        open() {
            this.modalShow = true;
            this.$nextTick(() => {
                this.initData();
            })
        },
        // 关闭弹窗
        close() {
            this.modalShow = false;
        },
        handleSureBtn() {
            let resultObj = this.getData();
            this.$emit('on-finish', resultObj);
            this.modalShow = false;
        }

    }
};
</script>
<style lang="scss" scoped>
.page-right {
    text-align: right;
    margin-top: 16px;
}

.modal-footer {
    margin-top: 32px;
    text-align: right;

    button+button {
        margin-left: 16px;
    }
}
</style>
  